/* eslint-disable consistent-return */
import PropTypes from 'prop-types';
import prepareTranslate from '@/helpers/dictionary';
import { useNavigate } from 'react-router-dom';
import {
  ActionIcon,
  Button,
  Group,
  Menu,
  Text,
  Tooltip,
} from '@mantine/core';
import {
  IconAlertCircle,
  IconDots,
  IconEye,
  IconFilePlus,
} from '@tabler/icons-react';
import styles from './style.module.css';

const ColumnActions = (props) => {
  const {
    items = [],
    row = {},
    menuLabel,
  } = props;

  const navigate = useNavigate();

  const availableActions = {
    navigate: (id, rowData, title) => navigate(rowData.actionParams[title].path),
  };

  const availableIcons = {
    eyeIcon: <IconEye />,
    errorIcon: <IconAlertCircle />,
    addFileIcon: <IconFilePlus />,
  };

  const t = prepareTranslate();
  const id = row.id || row._id;

  const primaryItems = items.filter((e) => e.isPrimary);
  const secondaryItems = items.filter((e) => !e.isPrimary);

  const primaryComponents = primaryItems.map((primaryItem, index) => {
    const {
      title = '',
      action = () => {},
      icon,
      showLabel,
      showAction,
      loading,
    } = primaryItem;

    let modifiedIcon = icon;
    if (typeof icon === 'string') {
      modifiedIcon = availableIcons[icon];
    }
    const isShowingAction = showAction ? row[showAction] : true;

    if (!isShowingAction) {
      return;
    }

    const actionFunc = typeof action === 'function' ? action : availableActions[action];
    const bgColor = index % 2 === 0 ? '#C9F6EF' : '#DDE8FF';

    return (showLabel)
      ? <Button
          key={title}
          color="black"
          bg={bgColor}
          variant="light"
          leftSection={modifiedIcon}
          size="xs"
          onClick={() => { actionFunc(id, row, title); }}
          className={styles.rowaction}
          loading={ loading ? loading(id, row) : false }
        >
          <Text size="xs">{title}</Text>
        </Button>
      : <Tooltip label={title} key={title}>
        <ActionIcon
          color="gray"
          key={title}
          variant='outline'
          onClick={() => { action(id, row); }}
        >
          {modifiedIcon}
        </ActionIcon>
      </Tooltip>;
  });

  let secondaryComponents = null;

  if (secondaryItems.length) {
    secondaryComponents = (
      <Menu>
        <Menu.Target>
          <ActionIcon variant="light" color="blue">
            <IconDots stroke={1.5} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Label>{menuLabel || t('components.table.secondary')}</Menu.Label>
          {
            secondaryItems.map((secondaryItem) => {
              const {
                title = '',
                action = () => {},
                icon,
                showAction,
              } = secondaryItem;

              const isShowingAction = showAction ? row[showAction] : true;

              if (!isShowingAction) {
                return null;
              }

              return (
                <Menu.Item
                  key={title}
                  leftSection={icon}
                  onClick={() => { action(id, row); }}
                  className={styles.rowaction}
                >
                  {title}
                </Menu.Item>
              );
            })
          }
        </Menu.Dropdown>
      </Menu>
    );
  }

  return (
    <Group wrap="nowrap">
      {primaryComponents}
      {secondaryComponents}
    </Group>
  );
};

ColumnActions.propTypes = {
  items: PropTypes.array,
  row: PropTypes.object,
  menuLabel: PropTypes.string,
};

export default ColumnActions;
